import {
    LazyModule,
    createLazyComponent,
    registerLazyOrchestrator,
    type LazyComponent,
} from 'owa-bundling';
import type * as lazyIndex from './lazyIndex';
import type { CopilotSearchAnswerProps } from './components/CopilotSearchAnswer';
import { loadTableViewFromSearchTableQuery } from 'owa-mail-search';
import { endSearchSession } from 'owa-search-actions';

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(
    () => import(/* webpackChunkName: "CopilotSearchAnswer" */ './lazyIndex'),
    { name: 'CopilotSearchAnswer' }
);

// Lazy component for rendering in search results
export const LazyCopilotSearchAnswer: LazyComponent<{}, unknown, void> = createLazyComponent(
    lazyModule,
    (m: typeof lazyIndex) => m.CopilotSearchAnswer
);

// Lazy container that displays the copilot answer
export const LazyCopilotSearchAnswerContainer: LazyComponent<CopilotSearchAnswerProps, void> =
    createLazyComponent(lazyModule, (m: typeof lazyIndex) => m.CopilotSearchAnswerContainer);

registerLazyOrchestrator(
    loadTableViewFromSearchTableQuery,
    lazyModule,
    m => m.startCopilotSearchOrchestrator
);

registerLazyOrchestrator(endSearchSession, lazyModule, m => m.clearCopilotSearchOrchestrator);

// Re-export selectors for checking state
export { getCopilotSearchAnswer, getIsLoading } from './selectors/selectors';

// Re-export types
export type { ChatAnswer, ChatErrorType } from './types';
